import React from 'react'

function Box1() {
  return (
    <div className='w-full absolute sm:top-[100rem]  top-[142rem] h-[18rem] bg-[#3A3053]'>
     <p className='text-white text-3xl sm:text-4xl sm:left-[38%] absolute left-[2rem] top-[5rem]  font-medium'>Boost your links today</p>
     <button className='bg-[#29D1D1] hover:cursor-pointer hover:bg-[rgb(95,232,232)] sm:left-[44%] sm:top-[10rem] rounded-full text-2xl left-[5rem] absolute top-[9rem] pt-3 pb-3 pl-10 pr-10 text-white  font-medium'>Get Started</button>
    </div>
  )
}

export default Box1